import React, { useEffect } from "react";
import "./FlipCard.css";
import Aos from "aos";
import "aos/dist/aos.css";

export default function Pillars() {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <div style={{ paddingBottom: "50px" }}>
      <center>
        <div className="support-ban-gap">
          <div className="support-icon-container">
            <div
              className="support-icon-column"
              id="column1"
              data-aos="fade-up"
              data-aos-duration="2500"
            >
              <a href="/support/children&education/" aria-label="button">
                <div className="support-button-image-box">
                  <div className="support-button-image support-button-image-1-box" />
                  <h1 className="support-topic-overlay">
                    CHILDREN AND EDUCATION
                  </h1>
                </div>
              </a>
            </div>
            <div
              className="support-icon-column"
              id="column2"
              data-aos="fade-up"
              data-aos-duration="2500"
            >
              <a href="/support/wellbeing/" aria-label="button">
                <div className="support-button-image-box">
                  <div className="support-button-image support-button-image-2-box" />
                  <h1 className="support-topic-overlay">WELLBEING </h1>
                </div>
              </a>
            </div>
            <div
              className="support-icon-column"
              id="column2"
              data-aos="fade-up"
              data-aos-duration="2500"
            >
              <a href="/support/environment/" aria-label="button">
                <div className="support-button-image-box">
                  <div className="support-button-image support-button-image-3-box" />
                  <h1 className="support-topic-overlay">ENVIRONMENT</h1>
                </div>
              </a>
            </div>
          </div>
        </div>
      </center>
    </div>
  );
}
